import * as types from 'actions/types';
import initialState from 'store/initialState';

export default (state = initialState.selectedInternship, action) => {
  switch (action.type) {
    case types.SET_SELECTED_INTERNSHIP:
      if (action.internship) {
        return {
          ...action.internship,
        };
      }
      return state;
    case types.LOGOUT:
      return initialState.selectedInternship;
    default:
      return state;
  }
};
